import { Component, input } from '@angular/core';

import { IKUIBreacrumbDropdown, IKuiBreadcrumbLink } from './breadcrumb.model';

@Component({
    selector: 'kui-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class KuiBreadcrumbComponent {
    breadcrumbs = input<Array<IKUIBreacrumbDropdown | IKuiBreadcrumbLink>>();
}
